module.exports = __webpack_public_path__ + "f8799df659ff1ea15c4b7492c6c0338f.pdf";